import React from 'react';
import { withSessionSsr, getPublicToken } from "../../lib/sessionMiddleware";
import { getCanonicalPath } from "../../lib/canonical";
import useHook from '../../hooks/pages/preguntas-frecuentes/useHook';
import styles from './styles.module.scss';
import {
  Navbar,
  Wrapper,
  TituloSeccion,
  // SubtituloSeccion,
  Seccion,
  Footer,
  Loader,
  HeadTags,
  BtnFlotanteWhatsapp,
  ItemFaq,
  Container,
}from '../../components';

import {
  Button,
  useTheme,
} from '@mui/material';


const PreguntasFrecuentesPage = (props)=>{

  const faqs = props.pageProps.faqs;

  const theme = useTheme();

  const {
    mobile,
  } = useHook();

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs?.map(item => ({
      "@type": "Question",
      "name": item.attributes.pregunta,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.attributes.respuesta
      }
    })) || []
  };

  return(<>

    <HeadTags
      title="Preguntas frecuentes"
      description=""
      path={props.pageProps.pathname}
      schema={schema}
    />

    <Navbar/>

    <Seccion padding="40px 20px" paddingMobile="20px">
      <Wrapper>             
        <TituloSeccion align="center">Preguntas frecuentes</TituloSeccion>
        {/* <br/> */}
        {/* <SubtituloSeccion align="center">¡Conocé nuestros productos recomendados!</SubtituloSeccion> */}
        <br/><br/>
        <Container width="1000px">
          <div className={styles.contenedor}>
            {faqs?.map(item=>(
              <ItemFaq data={item} key={item.id} />
            ))}
          </div>
        </Container>

      </Wrapper>
    </Seccion>

    <br/><br/><br/>
        
    <Footer/>
 
    <BtnFlotanteWhatsapp/>
  </>);
};

export default PreguntasFrecuentesPage;

export const getServerSideProps = withSessionSsr(
  async function getServerSideProps(ctx) {
  
    const { req } = ctx;
        
    const publicToken = await getPublicToken(req);
    const fetchFaqs = async()=>{
      try{
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/faqs/get-all`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET
          },
        });
        let data = await result.json();
        // console.log("faqs", data.data)
        return (data?.data || []);
      }catch(err){
        console.log("e", err);
        return [];
      }     
    };

    let faqs = await fetchFaqs();

    return {
      props: {
        pathname: getCanonicalPath(req),
        faqs: faqs,
      },
    };    
  
  },
);